<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl" v-if="client">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ firma }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowa umowa
    </h1>
    <h1 class="mb-8 font-bold text-3xl" v-if="client == null">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('contracts')">Umowy</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowa umowa
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <div class="pr-6 pb-8 w-full" v-if="client">
            <text-input v-model="firma" label="Klient" disabled />
          </div>
          <div class="pr-6 pb-8 w-full" v-else>
            <multiselect-input v-model="form.client" :error="form.errors.client" label="Klient" :options="options" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" :searchable="true" />
          </div>

          <text-input v-model="form.number" :error="form.errors.number" class="pr-6 pb-8 w-full lg:w-1/2" label="Numer" :disabled="!disabled_number" />
          <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/3 lg:py-9" v-model:checked="disabled_number" label="Własny numer"/>

          <multiselect-input v-model="form.theme" :error="form.errors['theme.id']" label="Szablon" :options="themes" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" />

          <div class="pr-6 pb-8 w-full lg:w-1/2"></div>

          <multiselect-input v-model="form.price_list" :error="form.errors['price_list.id']" label="Cennik usług księgowych" :options="price_lists" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" />

          <multiselect-input v-model="form.price_list_kadry" :error="form.errors['price_list_kadry.id']" label="Cennik usługi kadrowej" :options="price_lists_kadry" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" />

          <shtax-checkbox class="pr-6 pb-8 w-full" v-model:checked.sync="form.has_promotion" :error="form.errors.has_promotion" :checked="form.has_promotion" label="Dodaj cennik promocyjny"  />
          <multiselect-input v-model="form.promotion_price_list" :error="form.errors['promotion_price_list.id']" label="Cennik promocyjny usług księgowych" :options="price_lists" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" class="pr-6 pb-8 w-full lg:w-1/2" :isDisabled="!form.has_promotion" />
          <text-input v-model="form.promotion_ends_on" :error="form.errors.promotion_ends_on" class="pr-6 pb-8 w-full lg:w-1/2" label="Zakończenie promocji" type="date" :disabled="!form.has_promotion" />

          <text-input v-model="form.signed_at" :error="form.errors.signed_at" class="pr-6 pb-8 w-full lg:w-1/2" label="Data podpisania (zawarcia)" type="date" />
          <text-input v-model="form.service_start_on" :error="form.errors.service_start_on" class="pr-6 pb-8 w-full lg:w-1/2" label="Data rozpoczęcia świadczenia usług" type="date" />
          <text-input v-model="form.started_from" :error="form.errors.started_from" class="pr-6 pb-8 w-full lg:w-1/2" label="Pierwszy miesiąc" type="date" />

          <shtax-text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.notice" :error="form.errors.notice" label="Uwagi"  />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Stwórz umowę</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'

export default {
  metaInfo: { title: 'Nowa umowa' },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    errors: Object,
    client: Object,
    clients: Array,
    new_number: String,
    price_lists: Array,
    price_lists_kadry: Array,
    themes: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        number: this.new_number,
        client: this.client ? this.client : null,
        signed_at: null,
        started_from: null,
        price_list: this.price_lists.at(-1),
        notice: null,
        theme: this.themes.at(-1),
        price_list_kadry: this.price_lists_kadry.at(-1),
        has_promotion: false,
        promotion_price_list: null,
        promotion_ends_on: null,
        service_start_on: null
      }),
      disabled_number: false,
      options: this.clients ? this.clients.map(client => {return {'id':client.id,'name':client.firma?client.firma.NAZWA_PELNA:client.nazwa_pelna}}) : null,
    }
  },
  methods: {
    store() {
      if (this.form.client == null) {
        Swal.fire({
          title: 'Ups!',
          icon: 'error',
          text: 'Wybierz klienta!',
          confirmButtonColor: '#3085d6',
        })
      } else {
        this.form.post(this.route('contracts.store', this.form.client.id))  
      }
    },
  },

  computed: {
    firma() {
      return this.client.firma ? this.client.firma.NAZWA_PELNA : this.client.nazwa_pelna
    }
  }
}
</script>
